<template>
  <div>
    <CoverBg
      show-text
      title="Services"
      text="Services - From Complex Medical Data Analysis to Helpful & Intelligible Statistics
       for a Better Global Health System"
    />
    <b-container class="main-container content-padding-t-b-100 pb-0">
      <b-row>
        <b-col
          v-for="(item, i) in serviceCardContext"
          :key="i"
          lg="6"
          md="12"
        >
          <ServiceCardItem
            :item="item"
          />
        </b-col>
      </b-row>
    </b-container>
    <CoverBg
      bg="cover-bg-page-bottom"
    />
  </div>
</template>

<script>
import CoverBg from '@/components/CoverBg';
import ServiceCardItem from '@/components/Services/ServiceCardItem';
import serviceCardContext from '@/constants/service/serviceCardContext';

export default {
  name: 'Services',
  components: { ServiceCardItem, CoverBg },
  data() {
    return {
      loading: false,
      serviceCardContext,
    };
  },
};
</script>
